export const Utils = {
	/* used in callback of axios */
	ValidateAxiosResponse: jsonResponse => {
		if (jsonResponse !== null && typeof jsonResponse === "object") {
			if (jsonResponse.isError) {
				throw new Error(jsonResponse.messageError)
			}
			return jsonResponse.objectModel
		}

		return new Error("Retorno não é um JSON válido.")
	},
	IsEmail(value) {
		if (!value || !String(value).trim()) return true

		const regex = /^([a-zA-Z0-9_\-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,7}|[0-9]{1,3})$/
		return String(value).split(";").every(mail => regex.test(mail.trim()))
	},
	EmailRule: value => Utils.IsEmail(value) || "E-mail inválido",
	ParseToDate(date) {
		if (!date) return date

		if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(date)) {
			const d = new Date(date)
			return isNaN(d) ? null : d
		}

		if(date instanceof Date && !isNaN(date)) date = new Date(date).toLocaleString(navigator.language, {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        })
		
		let array = date.split("/")
		let day = array[0]
		let month = array[1]
		let year = array[2].split(" ")[0]

		let hour = 0
		let minute = 0

		if (date.replace(/[^\d]/g, "").length > 8) {
			let time = array[2].split(" ")[1].split(":")
			hour = time[0]
			minute = time[1]
		}

		return new Date(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute))
	},
	ParseToString(value) {
		if (!value) return value
		return new String(value)
	},
	ToLowerKeys(obj) {
		return Object.keys(obj).reduce((accumulator, key) => {
			accumulator[key.toLowerCase()] = obj[key]
			return accumulator
		}, {})
	},
	ResetPropertiesValuesByPropertiesNamesBySelfType(obj, propertiesNames) {
		propertiesNames.forEach(propertyName => {
			if (Object.prototype.hasOwnProperty.call(obj, propertyName)) {
				let value = obj[propertyName]
				if (value === null || value === undefined) {
					obj[propertyName] = null
				} else if (typeof value === "string") {
					obj[propertyName] = ""
				} else if (typeof value === "number") {
					obj[propertyName] = 0
				} else if (typeof value === "boolean") {
					obj[propertyName] = false
				} else if (Array.isArray(value)) {
					obj[propertyName] = []
				} else if (typeof value === "object") {
					obj[propertyName] = {}
				} else {
					obj[propertyName] = null // Para outros tipos de dados ou não definidos
				}
			}
		})
		return obj
	},
	RGBToHex({ r, g, b }) {
		return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)
	},

	PickProps(list, props) {
		if(props.length < 1) {
			return list
		}
		return list.map(obj =>
			Object.fromEntries(
				props.filter(p => p in obj).map(p => [p, obj[p]])
			)
		)
	},

	async runPool(taskFns = [], limit = 8) {
		const executing = new Set()
		const results = []

		for (const fn of taskFns) {
			const p = Promise.resolve().then(fn)
			results.push(p)

			executing.add(p)
			const cleanup = () => executing.delete(p)
			p.then(cleanup).catch(cleanup)

			if (executing.size >= limit) {
				await Promise.race(executing)
			}
		}

		return Promise.allSettled(results)
	},
	FirstFormError(forms) {
		for (const form of forms) {
			const input = ((form && form.inputs) || []).find(input => input.hasError)
			const message = input && input.errorBucket[0]
			if (!message) continue

			const label = input.placeholder || input.label
			if (!label) return message

			return message === "Campo obrigatório" ? `Campo ${label} obrigatório.` : `${label}: ${message}`
		}
		return null
	}

}
export const ArrayUtils = {
	CompareArrayItems(array1, array2) {
		if (!array1 || !array2) return false

		if (array1.length !== array2.length) return false

		for (let i = 0; i < array1.length; i++) {
			if (!array2.includes(array1[i])) return false
		}
		return true
	},
	RemoveItemsFromArray(array1, array2) {
		if (!array1 || !array2) return array1

		return JSON.parse(JSON.stringify(array1.filter(item => !array2.includes(item))))
	},
	AddItemsToArray(array1, array2) {
		if (!array1 || !array2) return array1

		array2.forEach(item => {
			if (!array1.includes(item)) array1.push(item)
		})
		return JSON.parse(JSON.stringify(array1))
	},
}
